module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-3 col-xs-offset-3"
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("ON")]), _vm._v(" "), _c('option', [_vm._v("OFF")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('label', {
    attrs: {
      "for": "sample"
    }
  }, [_vm._v("Sample")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sample),
      expression: "sample"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "sample",
      "placeholder": "sample",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sample)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sample = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-xs-offset-3"
  }, [_c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Device File")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "devices"
    }
  }, [_vm._v("Device List")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devices),
      expression: "devices"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "id": "devices",
      "placeholder": "device1,device2,device3 or leave blank to update all devices"
    },
    domProps: {
      "value": (_vm.devices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devices = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "update col-xs-6 col-xs-offset-3"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isUpdating
    },
    on: {
      "click": _vm.updateSetting
    }
  }, [_vm._v("Update")])])])]), _vm._v(" "), _c('div', {
    staticClass: "result col-xs-6 col-xs-offset-3"
  }, [_c('div', [(_vm.isUpdating) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.result) + "\n    ")]), _vm._v(" "), (_vm.detailedResult) ? _c('pre', [_vm._v("\n      " + _vm._s(_vm.detailedResult) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fba60f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 37
// module chunks = 1